import { createV3Queries } from "@query/utils/createV3Queries";
import { payeeEligibilityRequirementsApi } from "@api";

export const queriesPayeeEligibilityRequirements = createV3Queries(
  "payeeEligibilityRequirementsApi",
  payeeEligibilityRequirementsApi
);
